export default state=>{
  if(state.wellness?.resource)
  {
        
    const resources=toArray(state.wellness.resource);
    const resourcesMap={HealthyLiving:[],WorkplacePerks:[],IncentivePrograms:[]};
    resources.forEach(res=>{
      if(res.footNotes)
      {
        res.footNotes=toArray(res.footNotes);
      }
      else{
        res.footNotes=[];
      }
      if(res.subsection=="HealthyLiving")
      {
        resourcesMap.HealthyLiving.push(res);
      }
      if(res.subsection=="WorkplacePerks")
      {
        resourcesMap.WorkplacePerks.push(res);
      }
      if(res.subsection=="IncentivePrograms")
      {
        resourcesMap.IncentivePrograms.push(res);
      }

    });
    state.wellness.resourcesMap=resourcesMap;      

  }

};

function toArray(val) {
  return Array.isArray(val) ? val : val?[val]:[];
}
    